import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import { rhythm } from '../utils/typography'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Menu from '../components/Menu'
import CTAButton from '../components/CTAButton'
import LeadForm from '../components/LeadForm'
import Hero from '../components/Hero'
import Heading from '../components/Heading'
import Divider from '../components/Divider'
import HeRow from '../components/HeRow'
import CenterRow from '../components/CenterRow'
import TriRoundRow from '../components/TriRoundRow'
import YouTube from '../components/YouTube'

class HomePage extends React.Component {
  render () {
  	const pages = [ ...this.props.route.pages ]
    const path = this.props.route.page.path

  	const meta = {
  		description: "ACS provides many industrial and power related markets with acoustic cleaners (sonic horns) to solve all their material handling problems. With experience dating back to 1989, ACS has tested methods and proven innovative products that get the job done right. Our products are also direct replacements for all major sonic horn brands making us a clear choice for your repair and upgrade situations.",
  		keywords: "Acoustic Cleaning Systems",
  		headline: "Acoustic Cleaning Systems: Acoustic cleaners done right.",
  		title: "Acoustic Cleaning Systems: Acoustic cleaners done right."
  	}

    return (
      <div className="home-page">
        <Helmet
          title={`${meta.title}`}
          meta={[
            { name: "Description", content: `${meta.description}`},
            { name: "Keywords", content: `${meta.keywords}`},
            { property: "og:title", content: `${meta.headline}`},
            { property: "og:description", content: `${meta.description}`},
            { property: "og:type", content: "article"},
            { property: "og:url", content: `${config.rootUrl}${path}`},
            { name: "twitter:card", content: "summary_large_image"},
            { name: "twitter:site", content: `${config.twitterHandle}` },
            { name: "twitter:creator", content: `${config.twitterHandle}` },
            { name: "twitter:title", content: `${meta.title}` },
            { name: "twitter:description", content: `${meta.description}` }
          ]}
        />
        <Hero headline='Our horns will blow you away.'
					images={[
						'/images/hero/0.jpg',
						'/images/hero/1.jpg',
						'/images/hero/2.jpg',
					]}
				>
					<LeadForm />
        </Hero>
        <div className="container page" >
          <Heading text="Join these great companies already cleaning with our horns." />
					<div className="current-clients">
						<div className="row center-xs start-sm">
							<div className="col-sm-3 col-xs-6">
								<p>Alstom</p>
							</div>
							<div className="col-sm-3 col-xs-6">
								<p>Dayton Power &amp; Light</p>
							</div>
							<div className="col-sm-3 col-xs-6">
								<p>Integrated Global Services</p>
							</div>
							<div className="col-sm-3 col-xs-6">
								<p>FuelTech</p>
							</div>
						</div>
						<div className="row center-xs start-sm">
							<div className="col-sm-3 col-xs-6">
								<p>Babcock</p>
							</div>
							<div className="col-sm-3 col-xs-6">
								<p>Dairyland Power</p>
							</div>
							<div className="col-sm-3 col-xs-6">
								<p>Southern Company</p>
							</div>
							<div className="col-sm-3 col-xs-6">
								<p>Hitachi</p>
							</div>
						</div>
					</div>
          <Divider />
          <HeRow img={<YouTube className="mini-hero" id="y1JirO3Rb5c" />} >
						<div>
							<h2>See the Magnum Difference</h2>
            	<p>
								Welcome to the future of acoustic cleaners. With a lower fundamental frequency, the ACS Magnum line
								out preforms the standard 75hz horns the industry has come to know. More cleaning power and direct
								replacements for most horns currently installed. Don’t take our word for it see the difference here!
            	</p>
						</div>
          </HeRow>
          <Divider />
          <TriRoundRow
            headlines={[
              'Magnum Horn',
              'Applications',
              'Parts & Maintenance'
            ]}

            images={[
              '/images/magnum-circle.jpg',
              '/images/applications.jpg',
              '/images/parts-maint-circle.jpg'
            ]}

            captions={[
              `Big things come in small packages. Find out all the new ACS Magnum horn offers and understand why it has become the ACS flagship cleaner. Same great technology, greater cleaning effectiveness for the toughest industry needs!`,
              `Acoustic cleaners provide an effective solution to buildup and material flow problems within a wide range of industries. They\'re effective for cleaning SCR catalysts without eroding the catalyst elements, supplementing mechanical rapping systems, reducing maintenance on hoppers, and supplementing steam sootblowers.`,
							`Whether it is spare parts, consultation, custom mounting, or on-site training ACS has the solution to your need. Let us be the one stop shop for all your acoustic cleaning problems. We have the knowledge to get you running right!`
            ]}

						links={[
							'/products/magnum/',
							'/applications/',
							'/service/'
						]}
          />
          <Divider />
					<CenterRow headline="Put Our Experience to Work for You." >
						Acoustic Cleaning Systems, Inc.’s experience dates back to 1983 and the key personnel have
						over 70 years combined experience in the utility industry and the application of acoustic
						cleaners in a variety of applications. ACS can supply or design an acoustic cleaning system to
						suit your requirements. From design to repair and everything in between, we simply blow our
						competition away.
          </CenterRow>
          {/* <Divider />

          <HeRow
            img={(
							<div className="mini-hero" style={{ backgroundImage: `url(/images/hero-row-2.jpg)` }}>
								<h2>How Does It Work?</h2>
								<div>
	                <CTAButton
	                  href='/contact-acoustic-cleaning/'
	                  label='Learn More'
	                  variation='secondary'
	                  mini={true}
	                />
	                <CTAButton
	                  href='/contact-acoustic-cleaning/'
	                  label='Contact Us'
	                  mini={true}
	                />
	              </div>
						 	</div>
						)}
            align="right"
          >
            <p>
              ACS sonic cleaners are simple in modular construction. They feature two basic components, bells for
              maximum output efficiency and a sound generator. Sonic horns are pneumatically operated to produce
              low frequency, high energy sound waves. Compressed air is forced over a precision-made titanium diaphragm,
              causing it to flex and produce a pressure pulse that is amplified by the horn’s bell.
            </p>
          </HeRow>
          <Divider />
          <Heading text="Here’s what our customers are saying about us." />
          <div className="row center-xs quote-row">
            <div className="col-xs-12 col-sm-6 col-md-4">
              <img src="/images/enerfab-logo.png" />
              <p>
                <i>
                  &quot;We have installed other brands of cleaning devices over the years, and we can highly recommend
                  your product as an equal in terms of both quality and service. Paul and his employees are very dedicated
                  to timely deliveries; from original quotations to drawing submittals to product delivery and technical
                  support.&quot;
                </i>
                <br />
                <br />
                <b>Ryan MacDonald</b>
              </p>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <img src="/images/enerfab-logo.png" />
              <p>
                <i>
                  &quot;We have installed other brands of cleaning devices over the years, and we can highly recommend
                  your product as an equal in terms of both quality and service. Paul and his employees are very dedicated
                  to timely deliveries; from original quotations to drawing submittals to product delivery and technical
                  support.&quot;
                </i>
                <br />
                <br />
                <b>Ryan MacDonald</b>
              </p>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <img src="/images/enerfab-logo.png" />
              <p>
                <i>
                  &quot;We have installed other brands of cleaning devices over the years, and we can highly recommend
                  your product as an equal in terms of both quality and service. Paul and his employees are very dedicated
                  to timely deliveries; from original quotations to drawing submittals to product delivery and technical
                  support.&quot;
                </i>
                <br />
                <br />
                <b>Ryan MacDonald</b>
              </p>
            </div>
          </div> */}
      	</div>
    	</div>
    )
  }
}

HomePage.propTypes = {}

HomePage.defaultProps = {}

HomePage.data = {
  menuLabel: 'Home',
  menuShortDescription: 'Acoustic Cleaning Services, Inc.'
}

export default HomePage



// WEBPACK FOOTER //
// ./index.js